<script>
import VehicleListingsBase from "@/components/VehicleListings/VehicleListingsBase.vue";

export default {
  name: "VehicleListingsRecentPriceDrops",
  extends: VehicleListingsBase,
  skipVehicleListingsAutoFetch: true, // We handle fetching ourselves after setting up filters
  mounted() {
    this.innerFilters = [{ "tags.tag": { equals: "Price Drop" } }];
    this.innerSorting = [
      {
        "tags.time_created": "desc",
        "tags.metadata.percent_change": "desc",
        _score: "desc"
      }
    ];
    this.getVehicles();
  }
};
</script>
